import React from "react";
import { Typography } from "antd";
const { Title, Paragraph } = Typography;

const ContactUs = () => {
  return (
    <div>
      <Title level={1}>Contact Us</Title>
      <Paragraph className="common-paragraph">
        Get more information about our products and services. Please be specific about the kind of
        information you need.
      </Paragraph>
      <Paragraph className="common-paragraph">Thank you!</Paragraph>
      <Paragraph className="common-paragraph">
        Chevron Technology Marketing
        <br />
        100 Chevron Way, Suite 10-3336
        <br />
        Richmond, CA 94801
        <br />
        Email: <a href="mailto:techma@chevron.com">techma@chevron.com</a>
      </Paragraph>
    </div>
  );
};

export default ContactUs;